import {Select, MenuItem} from '@mui/material';
import React from 'react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {getCountryName} from './Trans.js';

const CountryCombo = (props) => {
	const gStorage = useGlobalStorage();
	let c_arr = [];

	const ccGetCountryName = country => getCountryName(country, gStorage.conn.user);

	if (props.allowNone)
		c_arr.push({id: 0, fi: '--', en: '--', swe: '---'});

	gStorage.lists.countrylist.forEach((country, ind) => {
		c_arr.push(country);
	});

	return (
		<>
		<Select 
		    size='small'
		    value={props.value}
		    onChange={props.onChange}
		    style={props.style}
		>
			{c_arr.map((country, ind) => {
				return (<MenuItem key={country.id} value={country.id}>{ccGetCountryName(country)}</MenuItem>);
			})}
		</Select>
		</>);
}

export default CountryCombo;
